<template>
  <div class="row mt-4 mb-2 inner-nav-buttons">
    <router-link
      :to="{ name: 'campaign-details', params: { id: campaign.id } }"
      class="col-20 col-sm-6 col-md-4 mt-3 mt-sm-0 ml-0 ml-sm-3"
    >
      {{ $t('view-UserProfile.button.nav.about') }}
    </router-link>

    <router-link
      v-if="!isAdvertiser"
      :to="{ name: 'campaign-influencer-messages', params: { id: campaign.id } }"
      class="col-20 col-sm-6 col-md-4 mt-3 mt-sm-0 ml-0 ml-sm-3"
    >
      {{ $t('view-CampaignsMembers.button.nav.user-messages') }}
      <message-marker v-if="influencerHasMessage()" />
    </router-link>

    <router-link
      v-if="!isAdvertiser"
      :to="{ name: 'campaign-influencer-files', params: { id: campaign.id } }"
      class="col-20 col-sm-6 col-md-4 mt-3 mt-sm-0 ml-0 ml-sm-3"
    >
      {{ $t('view-CampaignsMembers.button.nav.user-files') }}
    </router-link>

    <router-link
      v-if="isAdvertiser"
      :to="{name: 'campaign-members'}"
      class="col-20 mt-3 mt-sm-0 col-sm-6 col-md-4 ml-0 ml-sm-3"
    >
      {{ $t('view-CampaignsMembers.button.nav.members') }}
    </router-link>

    <router-link
      v-if="isAdvertiser"
      :to="{name: 'campaign-report'}"
      class="col-20 mt-3 mt-sm-0 col-sm-6 col-md-4 ml-0 ml-sm-3"
    >
      {{ $t('view-CampaignsMembers.button.nav.report') }}
    </router-link>

    <router-link
      v-if="!isAdvertiser"
      :to="{name: 'campaign-report-influencer'}"
      class="col-20 mt-3 mt-sm-0 col-sm-6 col-md-4 ml-0 ml-sm-3"
    >
      {{ $t('view-CampaignsMembers.button.nav.report') }}
    </router-link>
  </div>
</template>

<script>
import '../../../assets/scss/inner-nav-buttons.scss'
import MessageMarker from '../../../components/MessageMarker.vue'

export default {
  components: {
    'message-marker': MessageMarker
  },
  props: {
    campaign: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    isAdvertiser () {
      return this.$store.state.user.profile.type === 'advertiser'
    }
  },
  methods: {
    influencerHasMessage () {
      return !this.isAdvertiser && this.$store.state.campaignsMessages.unreaded[this.campaign.id] && true
    }
  }
}
</script>
